import { render, staticRenderFns } from "./form.vue?vue&type=template&id=d01697f4&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=d01697f4&prod&lang=less&scoped=true"
import style1 from "./form.vue?vue&type=style&index=1&id=d01697f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01697f4",
  null
  
)

export default component.exports